"use strict";
/**
 * Core domain types for the grid world.
 *
 * The world is a rectangular tile grid in the RPG Maker tradition: everything
 * lives on integer tile coordinates, `x` growing right and `y` growing down,
 * with (0, 0) at the top-left. Nothing in this package knows about pixels — the
 * renderer is the only thing that multiplies a tile by a tile size.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIFE_STAGES = exports.DIRECTIONS = exports.OBJECT_KINDS = exports.TILE_CHARS = exports.TILE_KINDS = void 0;
// ---------------------------------------------------------------------- tiles
/**
 * What a single grid cell is made of.
 *
 * Deliberately just two: the dev-mode brush paints walls and floor, and a third
 * kind that nothing can draw yet would only be a trap for the editor.
 */
exports.TILE_KINDS = ['floor', 'wall'];
/** One character per tile, so a map can be written and diffed as ASCII art. */
exports.TILE_CHARS = {
    floor: '.',
    wall: '#',
};
// -------------------------------------------------------------------- objects
/** The furniture catalogue. `kind` is the only thing persisted; size and looks come from the spec. */
exports.OBJECT_KINDS = ['bed', 'table', 'chair', 'lamp', 'rug', 'chest', 'plant'];
// --------------------------------------------------------------------- actors
exports.DIRECTIONS = ['up', 'down', 'left', 'right'];
// ------------------------------------------------------------------------ pet
exports.LIFE_STAGES = ['baby', 'child', 'teen', 'adult'];
//# sourceMappingURL=types.js.map